import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { NotaryStatusKey } from '@/modules/notary/constants/NotaryStatusKey';

export class NotaryStatus extends Enum {
  key!: NotaryStatusKey;
  value!: string;
  color!: string;

  static NEW: NotaryStatus = {
    key: NotaryStatusKey.NEW,
    get value(): string {
      return Lang.t('notary.status.new');
    },
    color: '#ff7003'
  };

  static ACCOUNT_OPENING: NotaryStatus = {
    key: NotaryStatusKey.ACCOUNT_OPENING,
    get value(): string {
      return Lang.t('notary.status.account_opening');
    },
    color: '#ce2584'
  };

  static INSTRUCTIONS: NotaryStatus = {
    key: NotaryStatusKey.INSTRUCTIONS,
    get value(): string {
      return Lang.t('notary.status.instructions');
    },
    color: '#0231e8'
  };

  static DRAFTING: NotaryStatus = {
    key: NotaryStatusKey.DRAFTING,
    get value(): string {
      return Lang.t('notary.status.drafting');
    },
    color: '#cc136e'
  };

  static SIGNATURE: NotaryStatus = {
    key: NotaryStatusKey.SIGNATURE,
    get value(): string {
      return Lang.t('notary.status.signature');
    },
    color: '#800000'
  };

  static COMPLETED: NotaryStatus = {
    key: NotaryStatusKey.COMPLETED,
    get value(): string {
      return Lang.t('notary.status.completed');
    },
    color: '#19ca8f'
  };

  static WAITING_ON_CLIENT: NotaryStatus = {
    key: NotaryStatusKey.WAITING_ON_CLIENT,
    get value(): string {
      return Lang.t('notary.status.waiting_on_client');
    },
    color: '#ff6347'
  };

  static SUSPENDED: NotaryStatus = {
    key: NotaryStatusKey.SUSPENDED,
    get value(): string {
      return Lang.t('notary.status.suspended');
    },
    color: '#e50000'
  };

  static NON_RESPONSIVE: NotaryStatus = {
    key: NotaryStatusKey.NON_RESPONSIVE,
    get value(): string {
      return Lang.t('notary.status.non_responsive');
    },
    color: '#667684'
  };

  static INCOMPLETE: NotaryStatus = {
    key: NotaryStatusKey.INCOMPLETE,
    get value(): string {
      return Lang.t('notary.status.incomplete');
    },
    color: '#F97068'
  };
}
